@if (inputControl) {
  @if (mode === 'advanced') {
    <rt-select2
      withSearch
      [formControl]="inputControl"
      [disableLocalSearch]="true"
      [searchControl]="searchControl"
      [items]="optionOptions"
      [hiddenItems]="hiddenItems"
      [compareItemsFn]="compareItems"
      [overlayMinWidth]="DropdownWidth.SmallX"
      [overlayPosition]="[OverlayPosition.BottomLeft, OverlayPosition.TopLeft]"
      (vsUpdate)="onScrollChange($event)"
      (selection)="state$.next($event)"
      (close)="closed.emit()"
      rt-overlay-origin
      class="main-select"
      #origin="rtOverlayOrigin"
    >
      <rt-select-trigger [placeholder]="placeholder" />
    </rt-select2>

    @if (showDatePicker) {
      <rt-views-date-range-picker
        [value]="datePickerValue"
        [dateRangeOrigin]="origin"
        (valueChange)="onDateValueChange($event)"
        class="option-date"
      />
    }
  }

  @if (mode === 'quick') {
    <div
      #origin="rtOverlayOrigin"
      rt-overlay-origin
      [class.date-picker]="showDatePicker"
      class="quick-mode"
    >
      @if (!showDatePicker) {
        <rt-select2
          withSearch
          [formControl]="inputControl"
          [disableLocalSearch]="true"
          [searchControl]="searchControl"
          [items]="optionOptions"
          [hiddenItems]="hiddenItems"
          [compareItemsFn]="compareItems"
          (vsUpdate)="onScrollChange($event)"
          (selection)="state$.next($event)"
          (close)="closed.emit()"
          alwaysOpen
          class="main-select"
        >
          <ng-template rtSelectTrigger />
        </rt-select2>
      }

      @if (showDatePicker) {
        <rt-views-date-range-picker
          [hasTrigger]="false"
          [value]="datePickerValue"
          [dateRangeOrigin]="origin"
          (valueChange)="onDateValueChange($event)"
          class="option-date"
        />
      }
    </div>
  }
}
